var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2875 10.4875C21.7375 10.9375 21.7375 11.6125 21.2875 12.0625L12.85 20.5H9.25V16.9L17.6875 8.4625C18.1375 8.0125 18.8125 8.0125 19.2625 8.4625L21.2875 10.4875ZM20.5 11.275L18.475 9.25L16.7875 10.9375L18.8125 12.9625L20.5 11.275ZM10.375 17.35V19.375H12.4L18.025 13.75L16 11.725L10.375 17.35ZM8.125 22.75V21.625H23.875V22.75H8.125Z",
    fill: "#464E5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.861748997fd05df0d20c77cfeea8790d.svg";
export { ForwardRef as ReactComponent };